<div class="user-details-container">
  <div class="user-details-title">{{'account_settings.user_details.title' | translate}}</div>
  <div class="user-details-content">
    <form class="user-details-form" autocomplete="off" novalidate (ngSubmit)="onSubmitUserDetails()" [formGroup]="userDetails">
      <div class="form-fields first-form-row">
        <div class="d-flex flex-column first-form-col">
          <label class="input-label" for="firstName">{{'account_settings.form_label.first_name' | translate}}</label>
          <input required formControlName="firstName"
                  name="firstName"
                  type="text"
                  [(ngModel)]="currentUserDetails.firstName"
                  class="form-control"
                  [ngClass]="{'error-input': firstName.invalid && (firstName.dirty || firstName.touched) && firstName.errors.required}" />
        </div>
        <div class="d-flex flex-column input-full-width">
          <label class="input-label" for="lastName">{{'account_settings.form_label.last_name' | translate}}</label>
          <input required formControlName="lastName"
                  name="lastName"
                  type="text"
                  [(ngModel)]="currentUserDetails.lastName"
                  class="form-control"
                  [ngClass]="{'error-input': lastName.invalid && (lastName.dirty || lastName.touched) && lastName.errors.required}" />
        </div>
      </div>
      <div class="form-fields">
        <div class="d-flex flex-column first-form-col">
          <label class="input-label" for="email">{{'account_settings.form_label.email' | translate}}</label>
          <input required
                  formControlName="email"
                  name="email"
                  type="email"
                  [(ngModel)]="currentUserDetails.email"
                  class="form-control"
                  email
                  [ngClass]="{'error-input': email.invalid && (email.dirty || email.touched) && email.errors.required}" />
          <div *ngIf="email.invalid && (email.dirty || email.touched)" class="error-message">
            <div *ngIf="email.errors.invalidEmail && !email.errors.required">
              {{'register.invalid_email_message' | translate}}
            </div>
          </div>
        </div>
        <div class="d-flex flex-column input-full-width">
          <label class="input-label" for="phoneNumber">{{'account_settings.form_label.phone' | translate}}</label>
          <input required
                  formControlName="phoneNumber"
                  name="phoneNumber"
                  type="text"
                  [(ngModel)]="currentUserDetails.phone"
                  class="form-control"
                  [ngClass]="{'error-input': phoneNumber.invalid && (phoneNumber.dirty || phoneNumber.touched) && phoneNumber.errors.required}" />
        </div>
      </div>
    </form>
    <div class="profile-picture">
      <div class="d-flex flex-row flex-auto">
        <div class="picture-dropzone" *ngIf="!uploadedImage">
          <input type="file" title="" accept="image/*" class="picture-placeholder" (change)="onProfilePictureSelected($event)" #ImageInput>
        </div>
        <div class="picture-preview" *ngIf="uploadedImage">
          <img [src]="uploadedImage">
        </div>
        <div class="d-flex flex-column picture-right-content">
          <div class="profile-picture-title">{{'account_settings.user_details.profile_picture.title' | translate}}</div>
          <div class="profile-picture-description">{{'account_settings.user_details.profile_picture.description' | translate}}</div>
          <div class="action-button">
            <div class="d-flex flex-column">
              <span class="upload-message">{{'platform_settings.upload_logo_msg' | translate}}</span>
              <div class="btn file upload-image">
                <span>{{'platform_settings.upload_btn' | translate}}</span>
                <input type="file" accept="image/*" (change)="onProfilePictureSelected($event)" #ImageInput>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<achoo-popup #UserDetailNotificationPopup
             [isNotification]="true"
             modelTitle="{{popupTitle}}">
  <span>{{msgString}}</span>
</achoo-popup>



// WEBPACK FOOTER //
// ./src/app/main/account-setting/user-settings/user-details/user-details.component.html